import n from "react";
const i = "resize", a = (r) => {
  const [s, o] = n.useState({
    isMobile: !1,
    currentWidth: window.innerWidth
  });
  n.useEffect(() => (e(), window.addEventListener(i, e), () => window.removeEventListener(i, e)), []);
  const e = () => {
    const t = window.innerWidth, c = t <= r;
    o({
      isMobile: c,
      currentWidth: t
    });
  };
  return s.isMobile;
};
export {
  a as u
};
